// Datas de CALENDÁRIO (colunas DATE do Postgres) — não são instantes.
//
// O caminho que quebra: a coluna `campaigns_report.date` guarda 2026-07-27 sem
// hora nem fuso. O node-postgres transforma em Date, o JSON serializa como
// "2026-07-27T00:00:00.000Z" e o navegador em Brasília (UTC-3) lê isso como um
// INSTANTE — 26/07 às 21h. Qualquer getMonth()/getDate()/toLocaleDateString()
// então mostra 26/07: um dia a menos, o dia inteiro.
//
// A correção é não deixar a data passar por Date: lê-se os componentes do
// calendário direto da string.
//
// Use isto para colunas DATE (campaigns_report.date, invoices.due_date).
// Para colunas TIMESTAMP (created_at, paid_at) o valor É um instante e deve
// mesmo ser renderizado em hora local — nesses, continue usando Date.

interface CalendarParts {
  year: number;
  month: number;
  day: number;
}

/** Extrai ano/mês/dia de 'YYYY-MM-DD...' ou 'YYYYMMDD'. */
export function calendarParts(value: unknown): CalendarParts | null {
  const s = String(value ?? '');
  if (!s) return null;

  const iso = /^(\d{4})-(\d{2})-(\d{2})/.exec(s);
  if (iso) return { year: +iso[1], month: +iso[2], day: +iso[3] };

  const compact = /(\d{4})(\d{2})(\d{2})$/.exec(s);
  if (compact) return { year: +compact[1], month: +compact[2], day: +compact[3] };

  return null;
}

/** 'M/D' — rótulo curto para eixos e tabelas diárias. */
export function calendarShort(value: unknown): string {
  const p = calendarParts(value);
  return p ? `${p.month}/${p.day}` : String(value ?? '');
}

/** 'M/D/YYYY' — mesma ordem do toLocaleDateString em en-US, sem o desvio. */
export function calendarDate(value: unknown): string {
  const p = calendarParts(value);
  return p ? `${p.month}/${p.day}/${p.year}` : String(value ?? '');
}

/** YYYYMMDD numérico, para ordenar sem construir Date. */
export function calendarSortKey(value: unknown): number {
  const p = calendarParts(value);
  return p ? p.year * 10000 + p.month * 100 + p.day : 0;
}
